import * as React from "react"
import { Box, Typography, Chip } from "@mui/material"
import { ImageSeeker, IconSeeker } from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"


export default function SkuOption({ sku, isSelected, isSaving, onSelect, onImageClick }) {
    const handleImageClick = (e) => {
        e.stopPropagation()
        if (onImageClick && !isSaving) {
            onImageClick()
        }
    }

    return (
        <Box
            onClick={isSaving ? undefined : onSelect}
            sx={{
                display: 'flex',
                gap: 2,
                p: 1.5,
                border: isSelected ? '3px solid' : '1px solid',
                borderColor: isSelected ? 'success.main' : '#e5e7eb',
                borderRadius: 1,
                cursor: isSaving ? 'wait' : 'pointer',
                backgroundColor: isSelected ? '#ecfdf5' : '#fff',
                opacity: isSaving ? 0.7 : 1,
                transition: 'all 0.2s',
                '&:hover': {
                    borderColor: isSaving ? undefined : 'primary.light',
                    backgroundColor: isSaving ? undefined : (isSelected ? '#ecfdf5' : '#f9fafb')
                }
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', width: 24 }}>
                {isSelected ? (
                    <IconSeeker icon="square-check" sx={{ color: 'success.main', fontSize: 20 }} />
                ) : (
                    <Box sx={{
                        width: 18,
                        height: 18,
                        border: '2px solid #d1d5db',
                        borderRadius: '3px',
                        '&:hover': { borderColor: 'primary.main' }
                    }} />
                )}
            </Box>

            <Box
                sx={{
                    width: 60,
                    height: 60,
                    flexShrink: 0,
                    cursor: 'zoom-in',
                    '&:hover': {
                        opacity: 0.8
                    }
                }}
                onClick={handleImageClick}
            >
                <ImageSeeker
                    useSpinner
                    lazyLoad={false}
                    src={`${BACKEND_APIS.BACKEND}/sku/image/${sku.skuID}`}
                    sx={{
                        width: 60,
                        height: 60,
                        borderRadius: 1,
                        border: '1px solid #e5e7eb',
                        objectFit: 'contain',
                        backgroundColor: '#fff'
                    }}
                />
            </Box>

            <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
                    {sku.skuName}
                </Typography>

                {sku.line && (
                    <Typography variant="caption" color="text.secondary" display="block">
                        Line: {sku.line}
                    </Typography>
                )}

                {sku.ean && (
                    <Typography variant="caption" color="text.secondary" display="block">
                        EAN: {sku.ean}
                    </Typography>
                )}

                {sku.reference && (
                    <Typography variant="caption" color="text.secondary" display="block">
                        Ref: {sku.reference}
                    </Typography>
                )}

                <Box sx={{ display: 'flex', gap: 0.5, mt: 1, flexWrap: 'wrap' }}>
                    <Chip
                        label={`ID: ${sku.skuID}`}
                        size="small"
                        variant="outlined"
                        sx={{ fontSize: '0.65rem', height: 18 }}
                    />
                    {sku.brand && (
                        <Chip
                            label={sku.brand}
                            size="small"
                            sx={{ fontSize: '0.65rem', height: 18, backgroundColor: '#e0e7ff', color: '#4338ca' }}
                        />
                    )}
                </Box>
            </Box>
        </Box>
    )
}
